import React from 'react';
import { FaRegQuestionCircle } from 'react-icons/fa';
const ChatBotButton = ({ onChatBotButtonClick }) => {
    const buttonText = 'Data Assistant';
    return (React.createElement("button", { onClick: onChatBotButtonClick, className: "chat-btn" },
        React.createElement(FaRegQuestionCircle, null),
        buttonText));
};
export default ChatBotButton;
//# sourceMappingURL=ChatbotButton.js.map